import React, { useEffect, useState } from "react";
import { loadYaml } from "../utils/loadYaml";
import { HeroSection } from "../components/herosection";
import { BifurcatedPromo } from "../components/BifurcatedPromo";
import { FeatureGrid } from "../components/FeatureGrid";

interface Section {
  type: string;
  id?: string;
  [key: string]: any;
}

interface SectionsData {
  sections: Section[];
}

export const Cybersecurity: React.FC = () => {
  const [sections, setSections] = useState<Section[]>([]);

  useEffect(() => {
    loadYaml("/config/cybersecurity.yaml").then((data: SectionsData) => {
      setSections(data.sections);
    });
  }, []);

  return (
    <div>
      {sections.map((s, idx) => {
        switch (s.type) {
          case "hero":
            return <HeroSection carousel={[]} key={idx} {...s} id={s.id} />;
          case "bifurcatedPromo":
            return <BifurcatedPromo title={""} left={s.left || {}} right={s.right || {}} key={idx} {...s} id={s.id} />;
          case "featureGrid":
            return <FeatureGrid title={""} features={[]} key={idx} {...s} id={s.id} />;
          default:
            return null;
        }
      })}
    </div>
  );
};

export default Cybersecurity;
